import React from 'react';
import './article.css';

const Article = ({ imgUrl, date, title, text }) => (
  <div className="blog-container_article">
    <div className="blog-container_article-content">
      <div>
        <h3>{title}</h3>
        <p>{date}</p>
      </div>
      <p>{text}</p>
    </div>
    <div className="blog-container_article-content-link">
      <p>Eiusmod ad {'>'}</p>
    </div>
    <div className="blog-container_article-image">
      <img src={imgUrl} alt="blog_image" />
    </div>
  </div>
);

export default Article;
